import {
  AI_ONBOARDING_INITIAL_SNAPSHOT,
  LocalOnboardingRepository,
  verifyAiOnboardingPharmacistLicense,
} from '@pharmaplan/common';
import {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react';

import { useAppDispatch } from '../useAppDispatch';

import {
  OnboardingSnapshot,
  VerifyPharmacistLicenseInput,
} from '../../components/SignupFlow/AiCompanion/types';

interface IUseAiOnboardingState {
  signupRequestId: string | null;
}

const createInitialSnapshot = (): OnboardingSnapshot =>
  ({
    ...AI_ONBOARDING_INITIAL_SNAPSHOT,
  });

const useAiOnboardingState = ({
  signupRequestId,
}: IUseAiOnboardingState) => {
  const dispatch = useAppDispatch();
  const isMountedRef = useRef(true);
  const [snapshot, setSnapshot] = useState<OnboardingSnapshot>(
    createInitialSnapshot,
  );

  useEffect(() => {
    isMountedRef.current = true;

    return () => {
      isMountedRef.current = false;
    };
  }, []);

  const repository = useMemo(
    () =>
      new LocalOnboardingRepository({
        onSnapshotChange: (nextSnapshot) => {
          if (isMountedRef.current) {
            setSnapshot(nextSnapshot);
          }
        },
      }),
    [],
  );

  useEffect(() => {
    repository.reset();
  }, [repository, signupRequestId]);

  const verifyPharmacistLicense = useCallback(async ({
    firstName,
    lastName,
    licenseNumber,
  }: VerifyPharmacistLicenseInput) =>
    dispatch(
      verifyAiOnboardingPharmacistLicense({
        firstName,
        lastName,
        licenseNumber,
      }),
    ).unwrap(), [dispatch]);

  return {
    repository,
    snapshot,
    verifyPharmacistLicense,
  };
};

export default useAiOnboardingState;
